module.exports = __webpack_public_path__ + "img/spicy-tomatenpastasaus.2d9585fd.jpeg";